import emailValidator from '../../utils/Validate';

export const multiEmailValidationWithHookForm = (values: any): any => {
  const error: any = {
    email: {message: ''}
  };

  if (!values.email) {
    error.email.message = 'VALIDATORS.EMAIL_REQ';
  } else if (Array.isArray(values.email) && !values.email.length) {
    error.email.message = 'VALIDATORS.EMAIL_REQ';
  } else {
    const emailList = Array.isArray(values.email)
      ? values.email
      : values.email.toString().split(',');
    for (const email of emailList) {
      if (email.trim() !== '' && !emailValidator(email.trim())) {
        error.email.message = 'VALIDATORS.INVALID_EMAIL';
        break;
      }
    }
  }

  if (!error.email.message) {
    return {};
  }

  return error;
};
